<template>
  <div class="mb-5">
    <b-button size="sm" variant="secondary" v-on:click="download">Exportieren</b-button>
    <b-button size="sm" class="mr-3" variant="danger" v-on:click="calculateModal">Neu Berechnen</b-button>

    <public-result-modal ref="publicWinnersModal" v-bind:competition="competition" v-bind:age="age"></public-result-modal>
    <result-calculation-modal ref="resultCalculationModal" v-bind:competition="competition"></result-calculation-modal>
  </div>

</template>
<script>
import PublicModal from '@/components/competitions/prices/PublicModal'
import ResultCalculationModal from '@/components/competitions/prices/ResultCalculationModal'

export default {
  name: 'Prices',
  props: ['competition'],

  components: {
    publicResultModal: PublicModal,
    resultCalculationModal: ResultCalculationModal
  },

  data: function () {
    return {
      age: null,
      ageOptions: [{value: null, text: 'Bitte wählen'}, 3, 4, 5, 6, 7, 8],
      state: null,
      stateOptions: [
        { value: null, text: 'Bitte wählen...', disabled: true },
        { value: 'BW', text: 'Baden-Württemberg' },
        { value: 'BY', text: 'Bayern' },
        { value: 'BE', text: 'Berlin' },
        { value: 'BB', text: 'Brandenburg' },
        { value: 'HB', text: 'Bremen' },
        { value: 'HH', text: 'Hamburg' },
        { value: 'HE', text: 'Hessen' },
        { value: 'MV', text: 'Mecklenburg-Vorpommern' },
        { value: 'NI', text: 'Niedersachsen' },
        { value: 'NW', text: 'Nordrhein-Westfalen' },
        { value: 'RP', text: 'Rheinland-Pfalz' },
        { value: 'SL', text: 'Saarland' },
        { value: 'SN', text: 'Sachsen' },
        { value: 'ST', text: 'Sachsen-Anhalt' },
        { value: 'SH', text: 'Schleswig-Holstein' },
        { value: 'TH', text: 'Thüringen' }
      ],
      result: null
    }
  },

  mounted: function () {
    this.update()
  },
  watch: {
    age: function () {
      this.update()
    },

    state: function () {
      this.update()
    }
  },

  methods: {
    update: function () {
      if (this.age == null || this.state == null) {
        return
      }

      this.axios.get('competitions/' + this.competition.id + '/prices?age=' + this.age + '&state=' + this.state)
        .then((rsp) => {
          this.result = rsp.data
        })
    },

    download: function () {
      this.$eventHub.$emit('download', '/competitions/' + this.competition.id + '/prices')
    },

    calculateModal: function () {
      this.$refs.resultCalculationModal.show()
    },

    showPublicResults: function () {
      this.$refs.publicWinnersModal.show()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/competitions/prices/Prices.vue